import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const SANDBOX_API = `${BACKEND_URL}/api/sandbox`;

const SANDBOX_TOKEN_KEY = 'sandbox_token';
const SANDBOX_USER_KEY = 'sandbox_user';

export function getSandboxToken() {
  return localStorage.getItem(SANDBOX_TOKEN_KEY);
}

export function setSandboxToken(token) {
  localStorage.setItem(SANDBOX_TOKEN_KEY, token);
}

export function clearSandboxSession() {
  localStorage.removeItem(SANDBOX_TOKEN_KEY);
  localStorage.removeItem(SANDBOX_USER_KEY);
}

export function setSandboxUser(user) {
  localStorage.setItem(SANDBOX_USER_KEY, JSON.stringify(user));
}

export function getSandboxUser() {
  try {
    const raw = localStorage.getItem(SANDBOX_USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function authHeaders() {
  const t = getSandboxToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export const sandboxApi = {
  login: (email, password) =>
    axios.post(`${SANDBOX_API}/auth/login`, { email, password }),
  me: () => axios.get(`${SANDBOX_API}/auth/me`, { headers: authHeaders() }),
  stats: () => axios.get(`${SANDBOX_API}/stats`, { headers: authHeaders() }),
  listConvocatorias: () =>
    axios.get(`${SANDBOX_API}/convocatorias`, { headers: authHeaders() }),
  createConvocatoria: (payload) =>
    axios.post(`${SANDBOX_API}/convocatorias`, payload, { headers: authHeaders() }),
  updateConvocatoria: (id, payload) =>
    axios.put(`${SANDBOX_API}/convocatorias/${id}`, payload, { headers: authHeaders() }),
  deleteConvocatoria: (id) =>
    axios.delete(`${SANDBOX_API}/convocatorias/${id}`, { headers: authHeaders() }),
  listPostulaciones: (params = {}) =>
    axios.get(`${SANDBOX_API}/postulaciones`, { headers: authHeaders(), params }),
  scorePostulacion: (id, puntaje, observaciones) =>
    axios.put(
      `${SANDBOX_API}/postulaciones/${id}/calificacion`,
      { puntaje, observaciones },
      { headers: authHeaders() }
    ),
  setEstado: (id, estado, observaciones) =>
    axios.put(
      `${SANDBOX_API}/postulaciones/${id}/estado`,
      { estado, observaciones },
      { headers: authHeaders() }
    ),
  reset: () => axios.post(`${SANDBOX_API}/reset`, {}, { headers: authHeaders() }),
};
